import GenesisModal from './lib/GenesisModal';

window.customElements.define('g-modal', GenesisModal);